import { AUTOMATIC_EVALUATION, MANUAL_EVALUATION } from 'Constants/General';

const useEvaluation = ({
  addLessonSession,
  addLessonAutoEvaluation,
  module,
  isDraft,
  updateLessonSessionData,
  updateLesson,
}) => {
  const onCreateEvaluation = async formData => {
    const sessionData = { ...formData };

    const lessonObject = {};
    lessonObject.moduleId = module.id;
    lessonObject.name = sessionData.evaluationName;
    lessonObject.isDraft = isDraft;
    lessonObject.lessonType = MANUAL_EVALUATION;

    const { newLesson, updatedModules } = await addLessonSession(lessonObject);
    const { id } = newLesson;

    await updateLesson({ id }, updatedModules);
  };

  const onCreateAutoEvaluation = async formData => {
    const evaluationData = { ...formData };

    evaluationData.moduleId = module.id;
    evaluationData.name = evaluationData.evaluationName;
    evaluationData.isDraft = isDraft;
    evaluationData.lessonType = AUTOMATIC_EVALUATION;

    delete evaluationData.evaluationName;

    if (evaluationData.duration !== null) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const diffMins = Math.floor((evaluationData.duration - today) / 60000);

      evaluationData.duration = diffMins;
    }

    const { newLesson, updatedModules } = await addLessonAutoEvaluation(evaluationData);
    const { id } = newLesson;

    await updateLesson({ id }, updatedModules);
  };

  const onUpdateEvaluation = async formData => {
    const sessionData = { ...formData };

    const lessonObject = {};
    lessonObject.id = sessionData.id;
    lessonObject.name = sessionData.evaluationName;
    lessonObject.isDraft = isDraft;

    await updateLessonSessionData(lessonObject);
  };

  /**
   * Actualiza la configuración de la evaluación automática.
   * @param {Object} formData - Los datos de la evaluación automática.
   */
  const onUpdateAutoEvaluation = async formData => {
    const evaluationData = { ...formData };

    evaluationData.name = evaluationData.evaluationName;
    evaluationData.isDraft = isDraft;

    delete evaluationData.evaluationName;

    await updateLessonSessionData(evaluationData);
  };

  return {
    onCreateEvaluation,
    onCreateAutoEvaluation,
    onUpdateEvaluation,
    onUpdateAutoEvaluation,
  };
};

export default useEvaluation;
